'use strict';

import angular from 'angular';

function PositionTypeResource($resource) {
  return $resource('/api/groups/:groupId/positiontypes/:id/:controller', {
    id: '@id'
  }, {
    create: {
      method: 'POST',
      url: '/api/groups/:groupId/positiontypes'
    },
    update: { method: 'PUT' },
    getDefinedBy: {
      method: 'GET',
      isArray: true,
      params: { controller: 'definedby' }
    },
    getDefinedFor: {
      method: 'GET',
      isArray: true
    }
  });
}

PositionTypeResource.$inject = ['$resource'];

export default angular.module('georgeApp.positionTypeSvc', [])
  .factory('PositionTypeSvc', PositionTypeResource)
  .name;
